import { setLoading } from "../store/global/globalSlice";

export const setGlobalLoadingHandler=(dispatch, axios)=>{
    axios.forEach(item => {
        item.interceptors.request.use(
            configs => {
                dispatch(setLoading(true))
                return configs;
            },
            error => {
                return Promise.reject(error);
            });
    })


    axios.forEach(item => {
        item.interceptors.response.use(
            configs => {
                dispatch(setLoading(false))
                return configs;
            },
            error => {
                dispatch(setLoading(false))
                return Promise.reject(error);
            });
    })
}